import BaseContainer from "@base/container/BaseContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import TweenMax, {Expo, Power1, Sine, TweenLite} from "gsap";
import {Signals} from "@/Imports";
import Facade from "@/Facade";
import * as PIXI from "pixi.js";
import Config from "@/config/Config";
import PlaneConfig from "@/config/PlaneConfig";
import GameStatesEnum from "@/states/GameStatesEnum";
import BulletContainer from "@/containers/BulletContainer";

export default class PlaneAnimationContainer extends BaseContainer {

    static StateJetEngineOff = 'StateJetEngineOff'
    static StateJetEngineOn = 'JetEngineOn'
    static StateJetStart = 'StateJetStart'
    static StateJetLand = 'StateJetLand'
    static StateJetFlight = 'StateJetFlight'
    static StateJetBattle = 'StateJetBattle'

    constructor(data) {
        super(data)
        this.init()
    }

    init(data) {

        this.showGlass = true;

        this.container = new PIXI.Container()
        this.addChild(this.container)
      //  this.container.visible = false

        this.plane = new SpineAnimation('jetAnims')
        this.container.addChild(this.plane)
        this.plane.start (['JetEngineOff'], [false])

        this.planeOff = new SpineAnimation('jetAnims')
        this.container.addChild(this.planeOff)
        this.planeOff.start (['JetEngineOff'], [false])
    }

     reset(){
         this.showGlass = true;
     }

    setState(state, showGlass = true) {
        if (this.state === state && showGlass === this.showGlass){
            return
        }
        if (!showGlass){
            this.showGlass = showGlass;
        }
        this.changeAnimation(this.showGlass)

        if (this.state === state){
            return
        }
        switch ( state ) {
            case PlaneAnimationContainer.StateJetEngineOff:
                this.plane.start(['JetEngineOff'], [true])
                this.planeOff.start(['JetEngineOff'] , [true])
                break;
            case PlaneAnimationContainer.StateJetEngineOn:
                this.plane.start(['JetEngineOn'], [true])
                this.planeOff.start(['JetEngineOff'] , [true])
                break;
            case PlaneAnimationContainer.StateJetStart:
                this.plane.start (['JetEngineOff', 'JetEngineOn', 'JetLandIdle'], [false, false, true])
                this.planeOff.start(['JetEngineOff', 'JetEngineOn', 'JetLandIdle'], [false, false, true])
                break;
            case PlaneAnimationContainer.StateJetLand:
                this.plane.start(['JetLandIdle'] , [true])
                this.planeOff.start(['JetLandIdlePilotOff'] , [true])
                break;
            case PlaneAnimationContainer.StateJetFlight:
                this.plane.start(['JetFlightIdle'] , [true])
                this.planeOff.start(['JetFlightIdlePilotOff'] , [true])
                break;
            case PlaneAnimationContainer.StateJetBattle:
                this.plane.start(['hitRegular'] , [true])
                this.planeOff.start(['hitPilotOff'] , [true])
                break;
        }
        this.state = state
    }

    changeAnimation(showGlass){
        this.plane.visible = showGlass
        this.planeOff.visible = !showGlass
    }


}
